
import { Component, Prop, Vue } from "vue-property-decorator";
import { Emotion, Scene } from "../interfaces/Interfaces";
import DisplayOverviewGraph from "./DisplayOverviewGraph.vue";
import { mapGetters, mapMutations } from "vuex";

@Component({
  components: {
    DisplayOverviewGraph,
  },
  computed: {
    ...mapGetters("scenes", {
      getScenes: "getScenes",
    }),
    ...mapGetters("stimulus", {
      showOnlyFilteredData: "getShowOnlyFilteredData",
    }),
  },
  methods: {
    ...mapMutations("stimulus", {
      setShowOnlyFilteredData: "setShowOnlyFilteredData",
    }),
  },
})
export default class DisplayOverview extends Vue {
  private selectedSceneSliderValue: number = 0;
  private chartTypes: string[] = ["spiderweb", "pie", "column"];
  private selectedChart: string = "spiderweb";
  private getScenes!: Scene[];

  @Prop() private emotions!: Emotion[];
  @Prop() private selectedEmotions!: string[];
  @Prop() private emotionsWithFilters!: Emotion[];
  private showOnlyFilteredData!: boolean;
  private setShowOnlyFilteredData!: (value: boolean) => void;

  private get useOnlyFilterFileIds(): boolean {
    return !!this.showOnlyFilteredData;
  }

  private set useOnlyFilterFileIds(value: boolean) {
    this.setShowOnlyFilteredData(value);
  }

  private get baseEmotions(): Emotion[] {
    if (
      this.showOnlyFilteredData &&
      this.emotionsWithFilters &&
      this.emotionsWithFilters.length
    ) {
      return this.emotionsWithFilters;
    }
    return this.emotions;
  }

  //Returns the scene id from the selected slider value
  get selectedSceneId(): number {
    const reversedScenesArr: Scene[] = [...this.getScenes].reverse();
    if (this.selectedSceneSliderValue <= reversedScenesArr.length - 1) {
      const scene: Scene = reversedScenesArr[this.selectedSceneSliderValue];
      if (scene && scene.id) return scene.id;
      else return -1;
    } else return -1;
  }

  //Returns array of scenes names
  get scenesNames(): string[] {
    const scenesNames: string[] = this.getScenes.map(
      (scene: Scene, index: number): string =>
        scene.label ? scene.label : "Scene " + (index + 1)
    );
    scenesNames.unshift("Full video");
    return scenesNames.reverse();
  }

  // Filter out Neutral emotion data
  get removeNeutralEmotionCategory(): string[] {
    return this.selectedEmotions.filter((e) => e !== "Neutral");
  }

  get removeNeutralEmotion(): Emotion[] {
    return this.baseEmotions.filter((e) => e.type !== "Neutral");
  }

  private selectChartType(type: string): void {
    this.selectedChart = type;
  }

  private setInitialSliderValue(): void {
    this.selectedSceneSliderValue = this.scenesNames.length - 1;
  }

  mounted() {
    this.setInitialSliderValue();
  }
}
